module.exports = __webpack_public_path__ + "static/quiltedgreybunny-af50270f5932df83d083912fa69a12eb.jpeg";